export const debounce =(functionToDebounce, time = 1000)=>{
        setTimeout(()=>{
            functionToDebounce()
        },time)
} 